import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const HistoryDashbaord = () => {
    const [history, setHistory] = useState([]);

    useEffect(() => {
        const fetchHistory = async () => {
            const userId = localStorage.getItem("userId");
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/history/${userId}`);
            setHistory(res.data);
        };

        fetchHistory();
    }, []);

    return(
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4"> Your History </h1>
             {history.length === 0 && <p> No History yet. </p>}

             <div className="space-y-4">
                { history.map((item) => (
                    <Link to={`/session/${item._id}`} key={item._id}>
                        <div className="p-4 border rounded hover:bg-gray-100">
                            <h2 className="font-bold"> {item.role} </h2>
                            <p> {item.experience} years </p>
                        </div>
                    </Link>
                ))}
             </div>
        </div>
    );
};

export default HistoryDashbaord;